export const contentTableConfig = {
  title: '公告列表',
  propList: [
    { prop: 'noticeTitle', label: '公告标题', minWidth: '100' },
    { prop: 'createTime', label: '创建时间', minWidth: '100' },
    { prop: 'updateTime', label: '更新时间', minWidth: '100' },
    { prop: 'noticeContent', label: '公告内容', minWidth: '100', slotName: 'noticeContent' },
    {
      prop: 'update',
      label: '操作',
      minWidth: '60',
      slotName: 'update'
    },
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  showFooter: true
}
